import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { OccupationModel } from '@app/ps/models/occupation.model';
import { Restangular } from 'ngx-restangular';
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';

@Component({
  selector: 'occupation-approve',
  templateUrl: './occupation-approve.component.html',
  styleUrls: ['./occupation-approve.component.scss'],
})
export class OccupationApproveComponent implements OnInit {

  occupationObject: OccupationModel;
  loading = true;
  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private restangular: Restangular,
  ) {
    this.onApprove = this.onApprove.bind(this);
    this.onReject = this.onReject.bind(this);
  }

  async ngOnInit() {
    const id = (<DialogConfigData>this.dialogConfig.data).occupationId;
    if (id) {
      await this.loadOccupation(id);
    } else {
      this.occupationObject = (<DialogConfigData>this.dialogConfig.data).occupation;
    }
    this.loading = false;
  }

  onApprove() {
    this.occupationObject.finalSolutionState = FinalSolutionStateEnum.APPROVED;
    this.occupationObject.finalSolutionNote = null;
    this.update();
  }

  onReject() {
    this.occupationObject.finalSolutionState = FinalSolutionStateEnum.REJECTED;
    this.update();
  }

  private async loadOccupation(occupationId: number) {
    this.occupationObject = await this.restangular.one('occupations', occupationId)
      .get({loadCollections: ['parcel.title.ownerships']})
      .toPromise();
  }

  private update() {
    return this.restangular
      .one('occupations', this.occupationObject.id)
      .customPUT(this.occupationObject)
      .toPromise()
      .then((result) => {
        this.dialogRef.close(result);
      });
  }
}
